import axios from "@/axios.js";
import constants from "@/constants.js";
export default {
  async addWidget({ commit }, widgetObj) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/user/dashboard-widget`,
        widgetObj
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async getWidget({ commit }, userId) {
    try {
      const resObj = await axios.get(
        `${constants.gatewayServiceUrl}/user/dashboard-widget/${userId}`
      );
      var res = resObj.data.data.filter((obj) =>
        Object.keys(obj).some((key) => Object.values(obj).includes("ACTIVE"))
      );
      commit("SET_USER_WIDGETS", res);
      return resObj.data.data;
    } catch (error) {
      throw error;
    }
  },
  async removeWidget({ commit }, widgetObj) {
    try {
      const resObj = await axios.post(
        `${constants.gatewayServiceUrl}/user/dashboard-widget/remove`,
        widgetObj
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
};
